export default "__VITE_ASSET__c734527c__"